import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { TelefoneFormaterPipe } from './telefone-formater.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';


@NgModule({
    declarations: [
        TelefoneFormaterPipe,
        SafeUrlPipe,
        SafeHtmlPipe
    ],
    imports: [CommonModule],
    exports: [
        TelefoneFormaterPipe,
        SafeUrlPipe,
        SafeHtmlPipe
    ]
})

export class Pipes { }